module.exports = __webpack_public_path__ + "static/img/s2_middle_tit.b115801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/s2_middle_tit.png
// module id = w1wB
// module chunks = 0